module.exports = __webpack_public_path__ + "static/media/top@2x.5e6f623d.png";